export const USER_SEASON_USECASE_ERROR_MESSAGES = {
  RETRIEVAL_FAILED: 'Unable to load your team selection. Please try again.',
  UPSERT_FAILED: 'Unable to save your team selection. Please try again.',
};
